// For now, we need to set the api-key to sth invalid on a per request basis.
// (If we don't, it still takes precedence over the Auth header).
// Didn't get this to work more generally but will be cleaned up alongside
// our custom authentication flow.
export const HeadersWithoutApiKeyWorkaround = { headers: { 'x-api-key': '' } };
